import { validationResult } from '../utils/validationResult';
import { ValidationFailure } from './ValidationFailure';

export interface ValidationResult {
  isValid: boolean;
  failures: ValidationFailure[];
}

export const mergeValidationResults = (results: ValidationResult[]): ValidationResult => {
  return validationResult(results.flatMap(result => result.failures));
};

export const isValidationResult = (candidate: unknown): candidate is ValidationResult => {
  return (
    typeof candidate === 'object' &&
    candidate !== null &&
    'isValid' in candidate &&
    'failures' in candidate &&
    Array.isArray(candidate.failures)
  );
};
